import { Provider } from "jotai";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useManagers from "../../../../hooks/useManagers/useManagers";
import useTasks from "../../../../hooks/useTasks/useTasks";
import { StyledLeadList } from "../../LeadListPage/LeadList/LeadList";
import { LeadAutoItemContext } from "../LeadAutoItem/LeadAutoItemContext";
import LeadAutoItem from "../LeadAutoItem/LeadAutoItem";
import useLeadAutoList from "../useLeadAutoList";
import useRole from "../../../../hooks/useRole/useRole";
import usePanneauLeads from "../../../common/CarteLead/usePanneauLeads";
import { ONGLETS } from "../LeadAutoItem/panneau/ongletsLeadAuto";
const queryString = require("query-string");

const LeadAutoList = ({ isLoading }) => {
  const { leadAutoList, actions, leadAutoFilters } = useLeadAutoList();
  const { tasksByProduct } = useTasks();
  const { managers, contacts } = useManagers();
  const location = useLocation();
  const { myRole } = useRole();
  // Panneau de détail (un seul lead ouvert pour toute la liste).
  const panneau = usePanneauLeads(leadAutoList, ONGLETS);

  useEffect(() => {
    const parsed = queryString.parse(location.search, {
      arrayFormat: "bracket",
    });
    let newLeadFilters = {};
    if (Object.values(parsed).length > 0) {
      newLeadFilters = parsed;
      // Si le paramètre leadId est présent, on le transforme en lead_uuid pour la recherche
      if (parsed.leadId) {
        newLeadFilters.leadUuid = parsed.leadId;
        delete newLeadFilters.leadId;
      }
    }

    actions.resetLeadAutoFilters();
    const mergedFilters = {
      ...leadAutoFilters,
      ...newLeadFilters,
    };

    actions.onFetchLeadAutoList(mergedFilters, mergedFilters);
  }, [location.search]);

  if (!leadAutoList || isLoading) return null;

  return (
    <StyledLeadList>
      {leadAutoList.map((leadAutoItem) => {
        return (
          <div className="leadListCard la-conteneur" key={`leadAutoItem${leadAutoItem.id}`}>
            <LeadAutoItemContext.Provider
              value={{
                tasksByProduct: tasksByProduct["AUTO"],
                managers,
                contacts,
                onDeleteLead: actions.onDeleteLead,
                updateLeadInList: actions.updateLeadInList,
                panneau,
              }}
            >
              <Provider>
                <LeadAutoItem data={leadAutoItem} myRole={myRole} />
              </Provider>
            </LeadAutoItemContext.Provider>
          </div>
        );
      })}
    </StyledLeadList>
  );
};

export default LeadAutoList;
